module.exports = __webpack_public_path__ + "static/img/David-Klemmer.0e508f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David-Klemmer.jpg
// module id = I4mr
// module chunks = 0